import { useGetGroupInsights } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import { ReportSectionCard, ReportTopHeader } from 'styles/styled-components/report';
import style from 'styles/styled-components/style';
import { platform_index_mapper, platform_EN_name_mapper } from 'utils/platformMapper';

import RankingProfile from '../rank/RankingProfile';

function HighValueRanking() {
	const [groupId] = useGetSearchParams(['groupId']);

	const { data: groupInsights, isLoading: groupInsightsLoading } =
		useGetGroupInsights(groupId);
	const highPerformingCreators = groupInsights?.highPerformingCreators;

	if (groupInsightsLoading) {
		return (
			<ReportSectionCard _width="32%">
				<ReportTopHeader>고성과 크리에이터/팔로워 수</ReportTopHeader>
				<Grid flex="center" _height="100%">
					<CoreLoading color_type="gray" />
				</Grid>
			</ReportSectionCard>
		);
	}

	return (
		<>
			<ReportSectionCard _width="32%">
				<ReportTopHeader>고성과 크리에이터/팔로워 수</ReportTopHeader>
				{highPerformingCreators?.map((item, idx) => {
					return (
						<RankingProfile
							key={idx}
							platform={{
								code: 'ig',
								name: platform_EN_name_mapper[platform_index_mapper[0]],
							}}
							rank={idx + 1}
							profile={item?.profileImage}
							username={item?.username}
							biography={item?.biography}
							unit="명"
							followers={item?.followers}
						/>
					);
				})}
			</ReportSectionCard>
		</>
	);
}

const { Grid } = style;

export default HighValueRanking;
